// extracted by mini-css-extract-plugin
module.exports = {"header":"WorldData_header__3BqEh"};